import CustomSelect from "components/customs/dropdown";
import SearchBarComponent from "components/customs/searchbarV2";
import { ALLOCATION_STATUS_FILTER } from "constants/status";
import { dropdownSelectStyle } from "constants/style";
import useAuth from "hooks/useAuth";
import React from "react";
import styled from "styled-components";
import { canEditRoles } from "utility/constants";

const TableHeaderSection = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const SearchbarWrapper = styled.div`
  width: 20%;
  position: relative;

  input {
    border: 2px solid ${({ theme }) => theme.colors.black60};
    background: white;
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const EndorsementFilters = ({
  tableOption,
  onChangeSearch,
  handleChangeFilter,
  selectedStatusFilter,
}) => {
  const { user } = useAuth();

  const role = user?.type;

  if (!user) {
    return null;
  }

  return (
    <TableHeaderSection>
      <div>
        {canEditRoles.includes(role) ? (
          <CustomSelect
            placeholder="Status"
            name="statusFilter"
            styles={dropdownSelectStyle}
            onChange={handleChangeFilter}
            value={selectedStatusFilter}
            options={ALLOCATION_STATUS_FILTER}
            isMulti
            isSearchable={false}
            hideSelectedOptions={false}
            isLoading={tableOption.isLoading}
            isDisabled={tableOption.isLoading}
          />
        ) : null}
      </div>

      <SearchbarWrapper>
        <SearchBarComponent
          onChangeSearch={onChangeSearch}
          isDisabled={tableOption?.isLoading}
        />
      </SearchbarWrapper>
    </TableHeaderSection>
  );
};

export default EndorsementFilters;
